module.exports = __webpack_public_path__ + "img/balibodySh1.4618ba3b.png";